import type { Sport } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

export const MAX_RESULTS = 12;

export const useLatestSearchItems = (sport: Sport) => {
  const { currentUser } = useCurrentUserContext();
  const { update, lifecycle } = useLifecycle();

  const latestSearchedItems = lifecycle?.latestSearchedItems;

  const truncatedLatestSearchedItems = latestSearchedItems
    ? (latestSearchedItems[sport] || []).slice(0, MAX_RESULTS)
    : [];

  const addItemToLatestSearch = (s: any) => {
    if (!currentUser) return;
    const alreadyExist = truncatedLatestSearchedItems.find(
      latestSearchedItem =>
        latestSearchedItem.objectID === s.objectID &&
        s.index === latestSearchedItem.index
    );
    if (alreadyExist) {
      return;
    }
    const newArray = [
      {
        objectID: s.objectID,
        sport,
        index: s.index,
      },
      ...truncatedLatestSearchedItems,
    ];
    const itemToUpdate = {
      ...latestSearchedItems,
      ...{ [sport]: newArray.slice(0, MAX_RESULTS) },
    };
    update(LIFECYCLE.latestSearchedItems, itemToUpdate);
  };

  const getOptionalFilters = (index: string) =>
    truncatedLatestSearchedItems
      ? truncatedLatestSearchedItems
          .filter(item => item.index === index)
          // Push these results to the top of the list through <score=...>
          .map((item, i) => `objectID:${item.objectID}<score=${1000 - i}>`)
      : [];

  return {
    truncatedLatestSearchedItems,
    getOptionalFilters,
    addItemToLatestSearch,
  };
};
